import React, { useEffect, useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Banner from "../common/Banner";
import Slider from "react-slick";
import affordimg from "../../images/premium1.jpg";
import itHub from "../../images/it_hub.png";
import educationHub from "../../images/education_hub.png";
import financeHub from "../../images/finance_hub.png";
import postPropertyBanner from "../../images/Homepage/post-property.png";
import postPropertyBannermob from "../../images/Homepage/post-property-mob.jpg";
import questionMark from "../../images/Homepage/output.gif";
import homeLoan from "../../images/Homepage/HomeLoan.png";
import zeroInt from "../../images/Homepage/Zero.png";
import regist from "../../images/Homepage/Legal.png";
import inspection from "../../images/Homepage/Inspection.png";
import seller1pic from "../../images/seller1.jpg";
import seller2pic from "../../images/seller2.jpg";
import seller3pic from "../../images/seller3.jpg";
import housingExpert from "../../images/Homepage/expert.png";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCommercialTopProjects,
  fetchCommercialSellProjects,
  fetchCommercialRentProjects,
} from "../../redux/homeSlice";
import marker from "../../images/marker.png";
import axios from "axios";
import { MapContainer, TileLayer, Polygon, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Testimonial from "../Testimonial";
import { AppContext } from "../../context/AppContext";
import config from "../../config/config";
import TopProjects from "../project/TopProjects";
import { fetchProfileProperties } from "../../redux/profilePropertySlice";
import PremiumProjects from "../project/PremiumProjects";
import AllLocalitiesMap from "../common/AllLocalitiesMap";
import CommercialLease from "../CommercialLease";
import RecommendedSellers from "../RecommendedSellers";
import FeaturedCollection from "../common/FeaturedCollection";
import OfferedFacilities from "./OfferedFacilities";
import AdsBannerSection from "../common/AdsBannerSection ";
import ShowcaseAdSection from "../common/ShowcaseAdSection";
import NewBanner from "../common/NewBanner";
import NewRecommendedSellers from "../NewRecommendedSellers";
import NewTestimonial from "../NewTestimonial";
const Commercials = () => {
  const [wishlist, setWishlist] = useState([]);
  const dispatch = useDispatch();
  const {
    commercialTopProjects,
    commercialRentProjects,
    commercialSellProjects,
    status,
    error,
  } = useSelector((state) => state.home);
  const { properties, status1, error1 } = useSelector(
    (state1) => state1.profileProperty
  );

  const { user } = useContext(AppContext);
  const token = config.getAuthToken();
  useEffect(() => {
    dispatch(fetchCommercialTopProjects());
    dispatch(fetchCommercialSellProjects());
    dispatch(fetchCommercialRentProjects());
  }, [dispatch]);

  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-prev`} onClick={onClick}>
        {"<"}
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-next`} onClick={onClick}>
        {">"}
      </button>
    );
  };

  const sliderRef = useRef(null);
  const affordRef = useRef(null);
  const sellerRef = useRef(null);
  const premRef = useRef(null);
  const prem2Ref = useRef(null);

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
    if (sellerRef.current) {
      sellerRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
    if (sellerRef.current) {
      sellerRef.current.slickNext();
    }
  };

  const handlePrevClick1 = () => {
    if (affordRef.current) {
      affordRef.current.slickPrev();
    }
  };

  const handleNextClick1 = () => {
    if (affordRef.current) {
      affordRef.current.slickNext();
    }
  };

  const handlePrevClick2 = () => {
    if (premRef.current) {
      premRef.current.slickPrev();
    }
  };

  const handleNextClick2 = () => {
    if (premRef.current) {
      premRef.current.slickNext();
    }
  };
  const handlePrevClick3 = () => {
    if (prem2Ref.current) {
      prem2Ref.current.slickPrev();
    }
  };

  const handleNextClick3 = () => {
    if (prem2Ref.current) {
      prem2Ref.current.slickNext();
    }
  };

  const getAverage = (arr) => {
    if (!arr || arr.length === 0) return 0;
    const numbers = arr.map(Number); // Convert strings to numbers
    return (
      numbers.reduce((sum, num) => sum + num, 0) / numbers.length
    ).toFixed(2);
  };

  const formatPrice = (price) => {
    if (price >= 1_00_00_000) {
      return `${(price / 1_00_00_000).toFixed(2)} CR`; // Convert to Crores
    } else if (price >= 1_00_000) {
      return `${(price / 1_00_000).toFixed(2)} L`; // Convert to Lakhs
    } else if (price >= 1_000) {
      return `${(price / 1_000).toFixed(2)} K`; // Convert to Thousands
    } else {
      return `${price}`; // Return as is for smaller amounts
    }
  };

  const settings = {
    dots: false,
    infinite: true,

    speed: 1000,
    slidesToShow: 1, // Default: Show 3 slides
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 3, // Show only 1 slide when screen width is 991px or smaller
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Premium Projects
  const premiumpro = {
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    arrows: null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  // Affordable Projects
  const affordpro = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const affordprobg = {
    backgroundImage: `url(${affordimg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  // seller
  const seller = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  // testimonial
  const testimonial = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const feature = {
    arrows: false,
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false /* Disable arrows for smaller screens */,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const featureready = {
    backgroundImage: `url(${itHub})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const featuretown = {
    backgroundImage: `url(${educationHub})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const featureluxury = {
    backgroundImage: `url(${financeHub})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const [areaCoords, setAreaCoords] = useState(null);
  const [lonLat, setLonLat] = useState([26.9163447327997, 75.7884844894515]);

  const handleLatLon = (lat, lon) => {
    setLonLat([lat, lon]);
    setAreaCoords(null);
  };

  const [allLocalities, setAllLocalities] = useState([]);

  useEffect(() => {
    const fetchAllLocalities = async () => {
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_BASE_URL
          }/search/allLocalities?city_id=${1}&category=${"commercial"}&service=${"sell"}&type=${"office"}`
        );
        setAllLocalities(response.data?.data || []); // Update suggestions state

        // console.log(response?.data?.data[0]);
      } catch (error) {
        console.error("Error fetching localities:", error);
      }
    };

    fetchAllLocalities();
  }, []);

  const customIcon = new L.Icon({
    iconUrl: marker, // URL to your custom marker image
    iconSize: [85, 85], // Size of the icon
    iconAnchor: [16, 32], // Anchor position for the icon
    popupAnchor: [0, -32], // Position of the popup relative to the icon
  });

  const handleDispatch = () => {
    if (user?.data?.id != null) {
      dispatch(fetchProfileProperties(user?.data?.id));
    }
  };

  const [query, setQuery] = useState("");
  const handleQuery = (value) => {
    setQuery(value);
  };
  useEffect(() => {
    if (properties?.wishlist) {
      setWishlist(properties.wishlist.map(Number)); // Convert to integers
    }
  }, [properties]);
  useEffect(() => {
    handleDispatch();
  }, [user?.data?.id]);

  return (
    <div>
      {/* Banner */}
      {/* <Banner category="commercial" handleQuery={handleQuery} /> */}

      <NewBanner category="commercial" handleQuery={handleQuery} />

      {/* Top Project */}

      <TopProjects
        topProjects={commercialTopProjects}
        wishlist={wishlist}
        user={user}
        token={token}
        handleDispatch={handleDispatch}
      />

      <AdsBannerSection />

      {/* Premiums Projects */}

      <PremiumProjects
        title="Explore Our Commercial Projects To Buy"
        premiumProjects={commercialSellProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="commercial"
      />

      {/* Premiums Projects For Lease*/}

      <CommercialLease
        premiumProjects={commercialRentProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
      />

      {/* <AffordableProjects 
   title={'Explore Our Commercial Projects For Lease'}
    affordableProjects={commercialRentProjects} 
    user={user} token={config.getAuthToken()} 
    wishlist={wishlist}
     handleDispatch={handleDispatch}/> */}

      {/* Top Localities */}
      {allLocalities?.length > 0 && (
        <AllLocalitiesMap
          allLocalities={allLocalities}
          category={"commercial"}
          commercialServiceQuery={query}
          property_type={"office"}
        />
      )}

      <ShowcaseAdSection />

      {/* Featured Collections */}
      <FeaturedCollection category="commercial" />

      <section className="postProperty-section sectiontopgap">
        <Link to="/postProperty">
          <div className="container-fluid p-0">
            <div className="desk">
              <img src={questionMark} className="banner-mark" />
              <img src={postPropertyBanner} className="banner-image" />
            </div>

            <div className="mob">
              <img src={postPropertyBannermob} className="banner-image" />
            </div>
          </div>
        </Link>
      </section>

      {/* Offered Facilities */}
      <OfferedFacilities user={user} token={token} />
      {/* <section className="facility-section sectiontopgap">
        <div className="container">

          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#EB622E" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Offered Facilities</h1>
          </div>

          <div className='facilities' style={{ marginTop: '80px' }}>
            <div className='faci_row'>
              <div className='faci_col'>
                <div className='cardbase'>
                  <div className='ofaciicon'>
                    <img src={homeLoan} className='faci_img' />
                  </div>
                  <div className='cardcont'>
                    <div className='faci_title'>
                      <h3>Home Loan</h3>
                    </div>
                    <div className='faci_points'>


                      <p>Attractive Interest Rates</p>
                      <p>Greater Loan Eligibility</p>
                      <p>Loan Offers From Banks</p>

                    </div>

                  </div>
                  <div className='cardbtn'>
                    <Link to="/">
                      <button className="btn faci_button" type="button">
                        <span>Apply Now</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='faci_col'>
                <div className='cardbase'>
                  <div className='ofaciicon'>
                    <img src={zeroInt} className='faci_img' />
                  </div>
                  <div className='cardcont'>
                    <div className='faci_title'>
                      <h3>Zero Brokerage <br />Rentals</h3>
                    </div>
                    <div className='faci_points'>


                      <p>Hassel Free Property</p>
                      <p>Management Services.</p>

                    </div>

                  </div>
                  <div className='cardbtn'>
                    <Link to="/">
                      <button className="btn faci_button" type="button">
                        <span>Contact Now</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='faci_col'>
                <div className='cardbase'>
                  <div className='ofaciicon'>
                    <img src={regist} className='faci_img' />
                  </div>
                  <div className='cardcont'>
                    <div className='faci_title'>
                      <h3>Legal & Registration</h3>
                    </div>
                    <div className='faci_points'>

                      <p>End To End Legal  </p>
                      <p>Assistance in Property</p>
                      <p>Related Matters.</p>

                    </div>

                  </div>
                  <div className='cardbtn'>
                    <Link to="/">
                      <button className="btn faci_button" type="button">
                        <span>Contact Now</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='faci_col'>
                <div className='cardbase'>
                  <div className='ofaciicon'>
                    <img src={inspection} className='faci_img' />
                  </div>
                  <div className='cardcont'>
                    <div className='faci_title'>
                      <h3>Property Inspection</h3>
                    </div>
                    <div className='faci_points'>



                      <p>Get Your Property </p>
                      <p> Evaluated Inside-Out By</p>
                      <p>Professionals/Experts.</p>

                    </div>

                  </div>
                  <div className='cardbtn'>
                    <Link to="/">
                      <button className="btn faci_button" type="button">
                        <span>Contact Now</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>



            </div>
          </div>

        </div>
      </section> */}

      {/* Recommended Sellers */}
      {/* <RecommendedSellers /> */}
      <NewRecommendedSellers />
      {/* <section className="seller-section sectiontopgap">
        <div className="container">

          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#EB622E" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1 data-aos='fade-left'>Recommended Sellers</h1>
          </div>

          <div className="slider-controls">
            <button className="slider-btn prev-btn" onClick={handlePrevClick}>
              ❮
            </button>
            <button className="view-all-btn">View All</button>
            <button className="slider-btn next-btn" onClick={handleNextClick}>
              ❯
            </button>
          </div>

          <div className='content content_margin'>
            <Slider ref={sellerRef} {...seller}>
              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller1pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />

                      <h4>Aditi Sharma</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>  5+ years of Experience in Jaipur location</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Trusted Agent (DreamSakha verified)</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>500+ Buyers Served with 4+ ratings</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Authentic Listings</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller2pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />
                      <h4>Saurav Jain</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>5+ years of Experience in Jaipur location</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Trusted Agent (DreamSakha verified)</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>500+ Buyers Served with 4+ ratings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Authentic Listings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller3pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />

                      <h4>Manoj Jain</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>5+ years of Experience in Jaipur location</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Trusted Agent (DreamSakha verified)</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>500+ Buyers Served with 4+ ratings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Authentic Listings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

            </Slider>
          </div>

        </div>
      </section> */}

      {/* Testimonials */}
      {/* <Testimonial /> */}
      <NewTestimonial />
    </div>
  );
};

export default Commercials;
